export interface GraphContextBreadcrumbSegment {
  label: string;
  title?: string;
  current?: boolean;
  muted?: boolean;
  onClick?: () => void;
}

export interface GraphContextBreadcrumbState {
  backLabel?: string;
  backTitle?: string;
  onBack?: () => void;
  segments: GraphContextBreadcrumbSegment[];
}

function appendSeparator(host: HTMLElement): void {
  const separator = document.createElement('span');
  separator.className = 'graph-context-separator';
  separator.textContent = '/';
  host.appendChild(separator);
}

function appendChip(host: HTMLElement, segment: GraphContextBreadcrumbSegment): void {
  const chip = segment.onClick
    ? document.createElement('button')
    : document.createElement('span');
  chip.className = 'graph-context-chip';
  if (segment.current) chip.classList.add('current');
  if (segment.muted) chip.classList.add('muted');
  chip.textContent = segment.label;
  if (segment.title) chip.title = segment.title;
  if (segment.onClick && chip instanceof HTMLButtonElement) {
    chip.type = 'button';
    chip.addEventListener('click', segment.onClick);
  }
  host.appendChild(chip);
}

export function updateGraphContextBreadcrumb(state: GraphContextBreadcrumbState): void {
  const host = document.getElementById('graph-context-breadcrumb');
  if (!host) return;
  host.innerHTML = '';

  if (state.onBack && state.backLabel) {
    const back = document.createElement('button');
    back.type = 'button';
    back.className = 'graph-context-back';
    back.textContent = state.backLabel;
    if (state.backTitle) back.title = state.backTitle;
    back.addEventListener('click', state.onBack);
    host.appendChild(back);
    appendSeparator(host);
  }

  state.segments.forEach((segment, index) => {
    if (index > 0) appendSeparator(host);
    appendChip(host, segment);
  });
}
